<template>
  <div>
    <busca-ano-nivel-etapa @chosen="chosen"></busca-ano-nivel-etapa>
    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <v-flex xs12 class="mt-7" v-if="distribuicao.length > 0">
        <v-card>
          <v-col>
            <table class="table-siged" v-if="distribuicao.length > 0">
              <thead>
                <tr >
                  <th>Descrição da Atividade</th>
                  <th v-for="(p, index) in linhaPeriodo[0]" :key="index">
                    {{p.dspravadi }}
                  </th>
                </tr>
              </thead>
              <tbody>
                  <input type="hidden" :name="numitems = 0">
                <tr v-for="(atividade, index) in tabela" :key="index">
                  <td :class="classTotal(atividade.descricaoatividadeavaliativa)">{{atividade.descricaoatividadeavaliativa}}</td>
                  <td v-for="(periodo, index2) in atividade.periodos" :key="index2" :class="classTotal(atividade.descricaoatividadeavaliativa)">
                    <span v-if="periodo.vinculo > 0">
                      <InputTable
                        type="text"
                        class="input-notas"
                        :disabled="true"
                        v-model.number="periodo.valordistribuicao"
                        :data-index="index"
                        @input="inputChange"
                        @click.native="event => onClickInput(event, index)"/>

                    </span>
                    <span v-else-if="typeof periodo.total == 'undefined'">
                      <InputTable
                        @keydown="stopArrowsAction"
                        @click.native="event => onClickInput(event, index)"
                        @keypress="justNumbers"
                        @input="inputChange"
                        type="number"
                        class="input-notas"
                        :data-index="index"
                        v-model.number="periodo.valordistribuicao"
                        :msgsError="($v.distribuicao.$each[index].periodos.$each[index2].$invalid)? [`Pontos já lançados. Valor mínimo ${periodo.valormin}`] : []"/>
                      <!-- <div v-if="" class="validator-error helper-text"></div> -->
                    </span>
                    <span v-else>
                      {{exibirTotal(atividade.indicaatividade,index2)}}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div id="btn-acoes-b" v-if="linhaPeriodo.length != 0">
              <v-btn type="submit" @click="onSubmit(false)" :loading="loading && !loading2" small :disabled="loading2 || loading || !habilitarBotoes" color="teal white" class="teste me-2 rounded-sm font-weight-regular">Salvar</v-btn>
              <v-btn class="rounded-sm font-weight-regular" type="button" small color="" :loading="loading2" :disabled="loading2 || loading || !habilitarBotoes" @click="cancelar">Cancelar</v-btn>
            </div>
          </v-col>
        </v-card>
    </v-flex>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

    <div>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <h2>Etapas Escolar</h2>
          </v-card-title>
          <v-card-text>
            <p v-if="!listarEtapasTodos.length">
              Etapas Escolares já foram distribuidas ou não possuem grade cadastrada.
            </p>
            <div v-else>
              <span>Escolha abaixo quais etapas vão receber a distribuição:</span>
              <div v-for="etapa in listarEtapasTodos" :key="etapa.id" style="flex: 100%" >
                <CheckBox
                  v-model="escolhasEtapas"
                  :label="etapa.dsserie"
                  :val="etapa.cdserie"/>
              </div>
            </div>
            <div id="btn-acoes-b">
              <v-btn class="rounded-sm font-weight-regular" type="submit" color="teal" :disabled="!(escolhasEtapas.length)" small :loading="loading" dark @click="onSubmit(true)">Salvar</v-btn>
              <v-btn class="rounded-sm font-weight-regular" type="submit" small @click="cancelaEtapa">Cancelar</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import InputTable from '@/components/InputTable';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import BuscaAnoNivelEtapa from '@/components/BuscaAnoNivelEtapa';
import {
  required, maxLength, minLength, alpha, integer, minValue, maxValue
} from 'vuelidate/lib/validators';
const DNRepository = RepositoryFactory.get('distribuirNotas');
import _ from 'lodash';

export default {
  name: 'DistribuirNotas',
  components: {
    BuscaAnoNivelEtapa,
    InputTable,
  },
  data() {
    return {
      anoletivo:'',
      nivelescolar:'',
      etapaescolar:'',
      distribuicao:[],
      loading: false,
      loading2: false,
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      linhaX: 0,
      linhaY: 0,
      dialog: false,
      listarEtapa: '',
      escolhasEtapas:[],
      habilitarBotoes: false,
    };
  },
   validations() {
     return {
      distribuicao:{
        required,
        $each:{
          required,
          periodos: {
            $each: {
              minValue: function(campo, valor){
                if(campo.valormin == null || campo.valordistribuicao == null){ return true; }
                return parseFloat(campo.valordistribuicao) >= parseFloat(campo.valormin);
              },
            },
          },
        },
      },
     };
  },
  created() {
    document.addEventListener('keyup', this.onKeyUp);
  },
  destroyed() {
    document.removeEventListener('keyup', this.onKeyUp);
  },
  mounted() {
    this.$Progress.finish();
  },
  methods: {
    justNumbers(event){
      if(!event.key.match(/[0-9,]|,/)) { event.preventDefault(); }
    },
    onKeyUp(key) {
      let rowX = this.linhaX;
      let rowY = this.linhaY;
      let fim = this.tabela.length;

      switch(key.keyCode){
        case 37: rowY--; fim = rowX + 1; break;
        case 38: rowX--; fim = 0; break;
        case 39: rowY++; fim = rowX + 1; break;
        case 40: rowX++; break;
        default: return;
      }

      let items = [];
      for(rowX; (rowX >= 0 && rowX <= fim) || (key.keyCode == 38 && rowX > fim); rowX = (key.keyCode == 38)? rowX-1 : rowX+1){
        items = document.querySelectorAll(`.input-notas[data-index="${rowX}"]`);
        if(items.length > 0 && typeof items[rowY] !== 'undefined'  && items[rowY].firstElementChild.disabled == false){ break; }
      }
      if(typeof items[rowY] === 'undefined') { return; }
      this.linhaX = rowX;
      this.linhaY = rowY;

      let input = items[rowY].firstElementChild;
      input.focus();
    },
    stopArrowsAction(event) {
      if(event.keyCode === 38 || event.keyCode === 40) { event.preventDefault(); }
    },
    onClickInput(event, rowX) {
      this.linhaX = rowX;
      const items = document.querySelectorAll(`.input-notas[data-index="${rowX}"]`);
      for(const [index, item] of items.entries()) {
        if(item.firstElementChild === event.target) { return this.linhaY = index; }
      }
    },
    inputChange() {
      this.habilitarBotoes = true;
    },
    chosen(data){
      this.anoletivo = data.aaletivo.aaletivo;
      this.nivelescolar = data.cdinstruc.cdinstruc;
      this.etapaescolar = data.cdserie.cdserie;
      this.montar();
      if(this.etapaescolar != 0){
        this.escolhasEtapas = [this.etapaescolar]
      }else{
        this.todasEtapas();
      }
      this.habilitarBotoes = false;
    },
    async montar(){
      this.msgArrayError = [];

      try{
        this.$Progress.start();
        const response = await DNRepository.getMatriz({aaletivo: this.anoletivo, cdinstruc: this.nivelescolar, cdserie: this.etapaescolar});
        this.distribuicao = [];
        this.distribuicao = response.data.results;
        this.msgArrayError = [];
      }catch(error){
        if (error.response.data.status == 'SEARCH_NOT_FOUND') { this.msgArrayError.push(error.response.data.errorMessage); }
        this.distribuicao = [];
      }
      this.$Progress.finish();
    },
    async todasEtapas(){
      this.msgArrayError = [];
      try{
        this.$Progress.start();
        const response = await DNRepository.getEtapaGrade({aaletivo: this.anoletivo, cdinstruc: this.nivelescolar});
        this.listarEtapa = [];
        this.escolhasEtapas = [];
        this.listarEtapa = response.data.results;
        this.msgArrayError = [];
      }catch(error){
        if (error.response.data.status == 'SEARCH_NOT_FOUND') { this.msgArrayError.push(error.response.data.errorMessage); }
        this.listarEtapa = [];
        this.escolhasEtapas = [];
      }
      this.$Progress.finish();
    },
    exibirTotal(tipo, index){
      return this.distribuicao.filter(key => key.indicaatividade == tipo).reduce((total, valor) => total + parseFloat(valor.periodos[index].valordistribuicao || 0), 0);
    },
    async onSubmit(todos){
      if(this.etapaescolar === 0 && this.dialog == false){
        this.dialog = true;
      }else{
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.loading = true;
        this.$Progress.start();
        let linhas = this.distribuicao;
        let dados = [];
        for (let linha of linhas) {
          if(linha.identificadoratividade){
           for (var key in linha.periodos) {
              let periodo = linha.periodos[key];
              if(periodo.valordistribuicao != null || periodo.identificadordistribuirnotas != null){
                for(let etapa of this.escolhasEtapas){
                   dados.push({
                    identificadordistribuirnotas: periodo.identificadordistribuirnotas,
                    aaletivo: this.anoletivo,
                    cdinstruc: this.nivelescolar,
                    cdserie: etapa,
                    cdpravadi: periodo.cdpravadi,
                    identificadoratividade: linha.identificadoratividade,
                    valordistribuicao: periodo.valordistribuicao,
                  });
                }
              }
            }
          }
        }
        try{
          const { data } = await DNRepository.postDistribuicao(dados)

          this.submitText = data.message;
          this.snackbar = true;
          this.msgArrayError = [];
          this.habilitarBotoes = false;
        }
        catch (error){
          if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
          if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
          this.habilitarBotoes = true;
        }

        this.montar();
        this.$Progress.finish();
        this.loading = false;
        this.dialog = false;
        if(todos){
          this.escolhasEtapas = [];
          this.todasEtapas();
        }
      }

    },
    async cancelar(){
      this.loading2 = true;
      await this.montar();
      this.loading2 = false;
      this.habilitarBotoes = false;
    },
    cancelaEtapa(){
      this.dialog = false;
      this.escolhasEtapas = [];
    },
    classTotal(dado){
      if(dado == 'Total')
        return "total centro";
      else
        return "centro"
    }
  },
  computed: {
    tabela() {
      let lista = _.orderBy(this.distribuicao, function(item) {
        return item.indicaatividade == 'E';
      }, ['desc']);

      lista = _.orderBy(lista, function(item) {
        return item.indicaatividade == 'R';
      }, ['desc']);

      lista = _.orderBy(lista, function(item) {
        return item.indicaatividade == 'N';
      }, ['desc']);

      return lista;
    },
    linhaPeriodo(){
      return _.map(this.distribuicao, 'periodos');
    },
    listarEtapasTodos(){
      return this.listarEtapa;
    }
  },
};
</script>

<style scoped lang="scss">
  #btn-acoes-b {
    text-align: right;
    margin-top: 5px;

    .teste {
      color:white;
    }
  }
  .total{
    background-color: #CFD8DC
  }
</style>
